import { carouselData } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            深度盘点近期最值得关注的剧集热点与行业动态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300/40 transition-all cursor-pointer"
            >
              <div className="relative aspect-[21/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-1.5 group-hover:text-accent-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}